import PropTypes from 'prop-types'
import { SidebarProvider } from '../components/layout/SidebarProvider'

export const AuthLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-dark-primary" style={{ minHeight: '100dvh' }}>
    <SidebarProvider>
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">{children}</div>
    </SidebarProvider>
  </div>
)

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
}
